module.exports = __webpack_public_path__ + "static/product3-da7a81e470881323fd827b97a3128378.png";